import * as Types from '../../../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminOrdersInClaimsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OrderFilterQuery>;
  order?: Types.InputMaybe<Types.Scalars['Order']['input']>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type AdminOrdersInClaimsQuery = { __typename?: 'Query', adminOrders?: { __typename?: 'OrderPageGraphqlType', totalCount: number, edges: Array<{ __typename?: 'PaginatedOrderGraphqlTypeEdge', node: { __typename?: 'OrderGraphqlType', id: number, code: string, orderType: Types.EOrderType, orderAmount: number, status: Types.EOrderStatus, productGroupId: number, productGroupName: string, productId: number, productUseType: Types.EProductUseType, productName: string, productQuantity: number, bundleDeliveryCode: string, marketEventId?: number | null, deliveryFee?: number | null, extraDiscount?: number | null, regionDeliveryFee?: number | null, deliveryCompanyName?: string | null, deliveryCompanyCode?: string | null, trackingNumber?: string | null, receiverDetailAddress?: string | null, receiverAddress: string, receiverName: string, receiverZipCode: string, receiverPhoneNumber: string, receiverDeliveryMemo?: string | null, salesChannel: Types.ESalesChannel, salesChannelType: Types.ESalesChannelType, salesChannelOrderCode?: string | null, pointDiscount?: number | null, orderConvertedAt?: string | null, updatedAt: string, salesChannelProductName?: string | null, createdAt: string, hasActiveExchangeReDeliveryPromotionRelease?: boolean | null, group: { __typename?: 'OrderGroupGraphqlType', id: number, code: string, marketName?: string | null, marketId?: number | null, vendorId?: number | null, vendorName?: string | null, brandId?: number | null, brandName?: string | null, ordererName?: string | null, ordererPhoneNumber?: string | null, paymentMethod?: Types.EOrderPaymentMethod | null, paidAt?: string | null, salesChannelOrderGroupCode?: string | null, orderedAt?: string | null }, items?: Array<{ __typename?: 'OrderItemGraphqlType', itemId: number, itemQuantity: number, name: string }> | null, activeClaim?: { __typename?: 'OrderClaimGraphqlType', claimQuantity?: number | null, claimType: Types.EOrderClaimType, id: number, isWiredOwnDeliveryFault?: boolean | null, reason?: string | null, reasonType: Types.EOrderClaimReasonType, status: Types.EOrderClaimStatus, target: Types.EOrderClaimTarget } | null, claims?: Array<{ __typename?: 'OrderClaimGraphqlType', claimQuantity?: number | null, claimType: Types.EOrderClaimType, id: number, isWiredOwnDeliveryFault?: boolean | null, reason?: string | null, reasonType: Types.EOrderClaimReasonType, status: Types.EOrderClaimStatus, target: Types.EOrderClaimTarget, promotionReleaseDelivery?: { __typename?: 'OrderClaimDeliveryGraphqlType', deliveryCompanyId?: number | null, trackingNumber?: string | null } | null }> | null, support?: { __typename?: 'OrderSupportGraphqlType', id: number, status: Types.EOrderSupportStatus } | null } }> } | null };

export type AdminOrderInClaimQueryVariables = Types.Exact<{
  adminOrderId: Types.Scalars['Int']['input'];
}>;


export type AdminOrderInClaimQuery = { __typename?: 'Query', adminOrder: { __typename?: 'OrderGraphqlType', id: number, code: string, orderAmount: number, status: Types.EOrderStatus, productGroupId: number, productGroupName: string, productId: number, productUseType: Types.EProductUseType, productName: string, productQuantity: number, bundleDeliveryCode: string, marketEventId?: number | null, deliveryFee?: number | null, extraDiscount?: number | null, regionDeliveryFee?: number | null, deliveryCompanyName?: string | null, deliveryCompanyCode?: string | null, trackingNumber?: string | null, receiverDetailAddress?: string | null, receiverAddress: string, receiverName: string, receiverZipCode: string, receiverPhoneNumber: string, receiverDeliveryMemo?: string | null, salesChannel: Types.ESalesChannel, salesChannelType: Types.ESalesChannelType, pointDiscount?: number | null, orderConvertedAt?: string | null, updatedAt: string, salesChannelProductName?: string | null, createdAt: string, group: { __typename?: 'OrderGroupGraphqlType', id: number, code: string, marketName?: string | null, marketId?: number | null, vendorId?: number | null, vendorName?: string | null, brandId?: number | null, brandName?: string | null, ordererName?: string | null, ordererPhoneNumber?: string | null, paymentMethod?: Types.EOrderPaymentMethod | null, paidAt?: string | null }, items?: Array<{ __typename?: 'OrderItemGraphqlType', itemId: number, itemQuantity: number, name: string }> | null, activeClaim?: { __typename?: 'OrderClaimGraphqlType', claimQuantity?: number | null, claimType: Types.EOrderClaimType, createdAt: string, id: number, isWiredOwnDeliveryFault?: boolean | null, reason?: string | null, reasonType: Types.EOrderClaimReasonType, status: Types.EOrderClaimStatus, target: Types.EOrderClaimTarget, updatedAt: string } | null, claims?: Array<{ __typename?: 'OrderClaimGraphqlType', id: number, claimType: Types.EOrderClaimType, status: Types.EOrderClaimStatus }> | null } };

export type AdminCountOrderByLatestClaimStatusesQueryVariables = Types.Exact<{
  orderFilter: Types.OrderFilterQuery;
}>;


export type AdminCountOrderByLatestClaimStatusesQuery = { __typename?: 'Query', adminCountOrderByLatestClaimStatuses: Array<{ __typename?: 'CountOrderStatusesGraphqlType', count: number, status: string }> };

export type RedeliveryCompaniesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RedeliveryCompaniesQuery = { __typename?: 'Query', adminDeliveryCompanies: Array<{ __typename?: 'DeliveryCompanyGraphqlType', id: number, name: string }> };


export const AdminOrdersInClaimsDocument = gql`
    query AdminOrdersInClaims($filter: OrderFilterQuery, $order: Order, $pagination: Pagination) {
  adminOrders(filter: $filter, order: $order, pagination: $pagination) {
    edges {
      node {
        id
        code
        orderType
        orderAmount
        group {
          id
          code
          marketName
          marketId
          vendorId
          vendorName
          brandId
          brandName
          ordererName
          ordererPhoneNumber
          paymentMethod
          paidAt
          salesChannelOrderGroupCode
          orderedAt
        }
        status
        productGroupId
        productGroupName
        productId
        productUseType
        productName
        productQuantity
        items {
          itemId
          itemQuantity
          name
        }
        bundleDeliveryCode
        marketEventId
        deliveryFee
        extraDiscount
        regionDeliveryFee
        deliveryCompanyName
        deliveryCompanyCode
        trackingNumber
        receiverDetailAddress
        receiverAddress
        receiverName
        receiverZipCode
        receiverPhoneNumber
        receiverDeliveryMemo
        salesChannel
        salesChannelType
        salesChannelOrderCode
        pointDiscount
        orderConvertedAt
        updatedAt
        salesChannelProductName
        createdAt
        activeClaim {
          claimQuantity
          claimType
          id
          isWiredOwnDeliveryFault
          reason
          reasonType
          status
          target
        }
        claims {
          claimQuantity
          claimType
          id
          isWiredOwnDeliveryFault
          reason
          reasonType
          status
          target
          promotionReleaseDelivery {
            deliveryCompanyId
            trackingNumber
          }
        }
        support {
          id
          status
        }
        hasActiveExchangeReDeliveryPromotionRelease
      }
    }
    totalCount
  }
}
    `;

/**
 * __useAdminOrdersInClaimsQuery__
 *
 * To run a query within a React component, call `useAdminOrdersInClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrdersInClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrdersInClaimsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminOrdersInClaimsQuery(baseOptions?: Apollo.QueryHookOptions<AdminOrdersInClaimsQuery, AdminOrdersInClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrdersInClaimsQuery, AdminOrdersInClaimsQueryVariables>(AdminOrdersInClaimsDocument, options);
      }
export function useAdminOrdersInClaimsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrdersInClaimsQuery, AdminOrdersInClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrdersInClaimsQuery, AdminOrdersInClaimsQueryVariables>(AdminOrdersInClaimsDocument, options);
        }
export type AdminOrdersInClaimsQueryHookResult = ReturnType<typeof useAdminOrdersInClaimsQuery>;
export type AdminOrdersInClaimsLazyQueryHookResult = ReturnType<typeof useAdminOrdersInClaimsLazyQuery>;
export type AdminOrdersInClaimsQueryResult = Apollo.QueryResult<AdminOrdersInClaimsQuery, AdminOrdersInClaimsQueryVariables>;
export const AdminOrderInClaimDocument = gql`
    query AdminOrderInClaim($adminOrderId: Int!) {
  adminOrder(id: $adminOrderId) {
    id
    code
    orderAmount
    group {
      id
      code
      marketName
      marketId
      vendorId
      vendorName
      brandId
      brandName
      ordererName
      ordererPhoneNumber
      paymentMethod
      paidAt
    }
    status
    productGroupId
    productGroupName
    productId
    productUseType
    productName
    productQuantity
    items {
      itemId
      itemQuantity
      name
    }
    bundleDeliveryCode
    marketEventId
    deliveryFee
    extraDiscount
    regionDeliveryFee
    deliveryCompanyName
    deliveryCompanyCode
    trackingNumber
    receiverDetailAddress
    receiverAddress
    receiverName
    receiverZipCode
    receiverPhoneNumber
    receiverDeliveryMemo
    salesChannel
    salesChannelType
    pointDiscount
    orderConvertedAt
    updatedAt
    salesChannelProductName
    createdAt
    activeClaim {
      claimQuantity
      claimType
      createdAt
      id
      isWiredOwnDeliveryFault
      reason
      reasonType
      status
      target
      updatedAt
    }
    claims {
      id
      claimType
      status
    }
  }
}
    `;

/**
 * __useAdminOrderInClaimQuery__
 *
 * To run a query within a React component, call `useAdminOrderInClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderInClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderInClaimQuery({
 *   variables: {
 *      adminOrderId: // value for 'adminOrderId'
 *   },
 * });
 */
export function useAdminOrderInClaimQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderInClaimQuery, AdminOrderInClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderInClaimQuery, AdminOrderInClaimQueryVariables>(AdminOrderInClaimDocument, options);
      }
export function useAdminOrderInClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderInClaimQuery, AdminOrderInClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderInClaimQuery, AdminOrderInClaimQueryVariables>(AdminOrderInClaimDocument, options);
        }
export type AdminOrderInClaimQueryHookResult = ReturnType<typeof useAdminOrderInClaimQuery>;
export type AdminOrderInClaimLazyQueryHookResult = ReturnType<typeof useAdminOrderInClaimLazyQuery>;
export type AdminOrderInClaimQueryResult = Apollo.QueryResult<AdminOrderInClaimQuery, AdminOrderInClaimQueryVariables>;
export const AdminCountOrderByLatestClaimStatusesDocument = gql`
    query AdminCountOrderByLatestClaimStatuses($orderFilter: OrderFilterQuery!) {
  adminCountOrderByLatestClaimStatuses(orderFilter: $orderFilter) {
    count
    status
  }
}
    `;

/**
 * __useAdminCountOrderByLatestClaimStatusesQuery__
 *
 * To run a query within a React component, call `useAdminCountOrderByLatestClaimStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCountOrderByLatestClaimStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCountOrderByLatestClaimStatusesQuery({
 *   variables: {
 *      orderFilter: // value for 'orderFilter'
 *   },
 * });
 */
export function useAdminCountOrderByLatestClaimStatusesQuery(baseOptions: Apollo.QueryHookOptions<AdminCountOrderByLatestClaimStatusesQuery, AdminCountOrderByLatestClaimStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCountOrderByLatestClaimStatusesQuery, AdminCountOrderByLatestClaimStatusesQueryVariables>(AdminCountOrderByLatestClaimStatusesDocument, options);
      }
export function useAdminCountOrderByLatestClaimStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCountOrderByLatestClaimStatusesQuery, AdminCountOrderByLatestClaimStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCountOrderByLatestClaimStatusesQuery, AdminCountOrderByLatestClaimStatusesQueryVariables>(AdminCountOrderByLatestClaimStatusesDocument, options);
        }
export type AdminCountOrderByLatestClaimStatusesQueryHookResult = ReturnType<typeof useAdminCountOrderByLatestClaimStatusesQuery>;
export type AdminCountOrderByLatestClaimStatusesLazyQueryHookResult = ReturnType<typeof useAdminCountOrderByLatestClaimStatusesLazyQuery>;
export type AdminCountOrderByLatestClaimStatusesQueryResult = Apollo.QueryResult<AdminCountOrderByLatestClaimStatusesQuery, AdminCountOrderByLatestClaimStatusesQueryVariables>;
export const RedeliveryCompaniesDocument = gql`
    query RedeliveryCompanies {
  adminDeliveryCompanies {
    id
    name
  }
}
    `;

/**
 * __useRedeliveryCompaniesQuery__
 *
 * To run a query within a React component, call `useRedeliveryCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedeliveryCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedeliveryCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRedeliveryCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<RedeliveryCompaniesQuery, RedeliveryCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedeliveryCompaniesQuery, RedeliveryCompaniesQueryVariables>(RedeliveryCompaniesDocument, options);
      }
export function useRedeliveryCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedeliveryCompaniesQuery, RedeliveryCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedeliveryCompaniesQuery, RedeliveryCompaniesQueryVariables>(RedeliveryCompaniesDocument, options);
        }
export type RedeliveryCompaniesQueryHookResult = ReturnType<typeof useRedeliveryCompaniesQuery>;
export type RedeliveryCompaniesLazyQueryHookResult = ReturnType<typeof useRedeliveryCompaniesLazyQuery>;
export type RedeliveryCompaniesQueryResult = Apollo.QueryResult<RedeliveryCompaniesQuery, RedeliveryCompaniesQueryVariables>;